import React, { useCallback, useRef, useState } from "react";
import Header from "../components/site/Header";
import Footer from "../components/site/Footer";
import AiConcierge from "../components/site/AiConcierge";
import CategoryTabs from "../components/site/CategoryTabs";
import DestinationGrid from "../components/site/DestinationGrid";
import HomeHero from "../components/site/home/HomeHero";
import RetreatStyles from "../components/site/home/RetreatStyles";
import HowItWorks from "../components/site/home/HowItWorks";
import PopularThemes from "../components/site/home/PopularThemes";
import WhyUs from "../components/site/home/WhyUs";
import FeaturedGuides from "../components/site/home/FeaturedGuides";
import Newsletter from "../components/site/home/Newsletter";
import MonetizationBlocks from "../components/site/monetization/MonetizationBlocks";
import { useSeo } from "../hooks/useSeo";
import { organization, website } from "../lib/jsonld";

const JSON_LD = [organization(), website()];

export default function Home() {
  const [active, setActive] = useState("all");
  const sectionRef = useRef(null);

  useSeo({
    title: "YogaToYacht | Find Yoga, Wellness & Yacht Retreats",
    description: "Discover yoga retreats, wellness escapes, sailing retreats, and yacht experiences based on your destination, budget, and travel style.",
    path: "/",
    jsonLd: JSON_LD,
  });

  const handleNavigate = useCallback((id) => {
    if (id === "top") {
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }
    setActive(id);
    requestAnimationFrame(() => {
      sectionRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div data-testid="home-page" className="bg-brand-bg text-brand-ink">
      <Header onNavigate={handleNavigate} />
      <HomeHero />
      <RetreatStyles />
      <HowItWorks />

      {/* Live retreat catalogue */}
      <section ref={sectionRef} id="escapes" data-testid="escapes-section" className="mx-auto max-w-[1400px] px-6 pb-24 pt-24 md:px-10 md:pt-28">
        <div className="mb-10 flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="overline text-brand-inkSoft">Browse the catalogue</p>
            <h2 className="mt-3 font-display text-3xl leading-tight md:text-5xl">Explore curated retreats</h2>
          </div>
          <CategoryTabs active={active} onChange={setActive} />
        </div>
        <DestinationGrid category={active} />
      </section>

      <PopularThemes />
      <WhyUs />
      <FeaturedGuides />
      <MonetizationBlocks browseTo="/#escapes" />
      <Newsletter />
      <Footer />
      <AiConcierge />
    </div>
  );
}
